import { Box, ButtonNew as Button, Icon, Image, ModalDialogNew, Spacer, Text } from '@jfs/ui-new'
import { AepsButton } from '../AepsButton'
import { SubTitle } from '../SubTitle'
import { Title } from '../Title'

interface AadhaarCardStatusModelProps {
  status: 'LINKED' | 'NOT_LINKED'
  show: boolean
  onPrimaryButtonPress: any
  onSecondaryButtonPress: any
}

export const AadhaarCardStatusModel = ({
  status,
  show,
  onPrimaryButtonPress,
  onSecondaryButtonPress,
}: AadhaarCardStatusModelProps) => {
  if (!show) {
    return null
  }
  return (
    <ModalDialogNew type={'bottom'} show={true} backgroundColor="TRANSPARENT">
      <Box
        flexDirection={'column'}
        ph={16}
        pt={40}
        pb={16}
        borderTopLeftRadius={24}
        borderTopRightRadius={24}
        backgroundColor={'WHITE'}>
        <Box
          width={48}
          height={48}
          borderRadius={32}
          backgroundColor={status === 'LINKED' ? 'AVAILABLE_GREEN' : 'TRANSPARENT'}
          justifyContent="center"
          alignSelf={'center'}
          alignItems={'center'}>
          {status === 'LINKED' && <Icon id="TICKMARK" size={24} color={'WHITE'} />}
          {status === 'NOT_LINKED' && (
            <Image source={require('../../assets/icons/ic_unlinked.png')} width={48} height={48} />
          )}
        </Box>
        <Spacer size={24} />
        <Title title={DATA[status]['title']} />
        <Spacer size={8} />
        <SubTitle subTitle={DATA[status]['subTitle']} />
        <Spacer size={32} />
        <AepsButton
          onPress={onPrimaryButtonPress}
          title={DATA[status]['primaryButtonText']}
          disabled={false}
          iconId={status == 'LINKED' ? 'FINGERPRINT' : undefined}
        />
        {status === 'NOT_LINKED' && (
          <>
            <Spacer size={16} />
            <Button
              type={'secondaryFullWidth'}
              onPress={onSecondaryButtonPress}
              borderColor="PRIMARY"
              height={48}
              children={<Text color={'PRIMARY'}>{DATA[status]['secondaryButtonText']}</Text>}
            />
          </>
        )}
      </Box>
    </ModalDialogNew>
  )
}

const DATA = {
  NOT_LINKED: {
    title: 'Aadhaar not linked',
    subTitle: 'Your aadhaar is not linked with your bank account, link your aadhaar to proceed…',
    primaryButtonText: 'Proceed to link aadhaar',
    secondaryButtonText: 'Back to home',
  },
  LINKED: {
    title: 'Aadhaar Linked Successfully…',
    subTitle: 'Scan customer fingerprint to proceed with your transaction',
    primaryButtonText: 'Scan Fingerprint',
    secondaryButtonText: '',
  },
}
